import classNames from "classnames";

import { useMobileDevice } from "src/utils/hooks/viewport";

import logo from "_assets/images/180x180.png";

import { HEADER_HEIGHT } from "../constants";

import { CAccount } from "./CAccount";
// import { CNotification } from "./CNotification";

const Header = () => {
  const isMobile = useMobileDevice();
  return (
    <header
      className={classNames(
        "sticky top-0 bg-[#053c7f] w-screen flex items-center justify-between z-10",
      )}
      style={{ height: HEADER_HEIGHT, paddingInline: "10%" }}
    >
      <img src={logo} alt="" />
      <div className="flex gap-3 items-center">
        {/* {!isMobile && <CNotification />} */}
        <CAccount />
      </div>
    </header>
  );
};

export default Header;
